import { render, staticRenderFns } from "./teachingData.vue?vue&type=template&id=79c6a4bb&scoped=true&"
import script from "./teachingData.vue?vue&type=script&lang=js&"
export * from "./teachingData.vue?vue&type=script&lang=js&"
import style0 from "./teachingData.vue?vue&type=style&index=0&id=79c6a4bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c6a4bb",
  null
  
)

export default component.exports